// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FormOutlinedSvg from "@fishx/icons-svg/es/asn/FormOutlined";
import FishxIcon from '../components/FishxIcon';

var FormOutlined = function FormOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FormOutlinedSvg
  }));
};

FormOutlined.displayName = 'FormOutlined';
export default React.forwardRef(FormOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FormOutlined.js
// module id = 2824
// module chunks = 0